import type { ClaimAccountPort } from '../foundation/claim-account-link';
import { IdentityHttpClient } from './identity-http';

const CLAIM_ACCOUNT_OPERATION_NAMES = Object.freeze({
  claim: 'POST /auth/employee-invitations/claim',
  recover: 'POST /auth/employee-invitations/recover',
} as const);

/** Unauthenticated generated transport for the public invitation claim page. */
export function createClaimAccountPort(options: { readonly baseUrl: string; readonly fetch?: typeof fetch }): ClaimAccountPort {
  const client = new IdentityHttpClient({
    baseUrl: options.baseUrl,
    getToken: () => null,
    additionalOperations: [CLAIM_ACCOUNT_OPERATION_NAMES.claim, CLAIM_ACCOUNT_OPERATION_NAMES.recover],
    ...(options.fetch ? { fetch: options.fetch } : {}),
  });
  return {
    claim: async (token, password) => {
      await client.mutate({ operation: CLAIM_ACCOUNT_OPERATION_NAMES.claim, params: {}, body: { token, password } });
    },
    recover: async (email) => {
      await client.mutate({ operation: CLAIM_ACCOUNT_OPERATION_NAMES.recover, params: {}, body: { email } });
    },
  };
}
